import { Box, BoxProps } from '@mui/material';
import React from 'react';

const FlexBox: React.FC<BoxProps> = ({ ...props }) => {
  return <Box display="flex" {...props} />;
};

export default FlexBox;
